import React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';

import styles from './Explainer2Style';

import managerImage from '../../../img/w9.jpg';
import corporateImage from '../../../img/w5.jpg';
import optimusLogo from '../../../img/assets/optimus_logo500.png';

import text from '../../../text.js';

class Explainer2 extends React.Component {
    render() {
        return (
            <div style={styles.explainerContainer}>
                <h2 className="text-center col-xs-12 col-md-10" style={styles.servicesHeader}>Our Services</h2>
                <div className="row">
                    {/*Corporate*/}
                    <div className="col-xs-12" style={[styles.sectionBottom, styles.sectionBorder]}>
                        <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <div className="col-xs-12 col-md-4">
                                <div style={styles.imageDiv}>
                                    <img alt="Corporate Services" style={styles.image} className="img img-responsive" src={corporateImage} />
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6" style={styles.imageTextDiv}>
                                <h3 style={[styles.textHeaderStyle, styles.alignLeft, styles.positionHeader]}>{text.enterpriseHeading}</h3>
                                <p style={[styles.alignLeft, styles.positionText, styles.justify]}>
                                    {text.enterpriseDescription}
                                    <Link to="/services" style={styles.explainerLink}>
                                        Learn more
                                        <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                    {/*Executives*/}
                    <div className="col-xs-12" style={[styles.section, styles.sectionBorder]}>
                        <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>

                            {/* Only visible on large screens*/}
                            <div className="col-xs-12 col-md-6 visible-lg visible-md" style={styles.imageTextDiv}>
                                <h3 style={[styles.textHeaderStyle, styles.alignRight, styles.positionHeader]}>{text.executiveHeading}</h3>
                                <p style={[styles.alignRight, styles.positionText, styles.justify]}>
                                    {text.executiveDescription}
                                    <Link to="/services" style={styles.explainerLink}>
                                        Learn more
                                        <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                                    </Link>
                                </p>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div style={styles.imageDiv}>
                                    <img alt="Executive Services" style={styles.image} className="img img-responsive" src={managerImage} />
                                </div>
                            </div>

                            {/* Only visible on small screens */}
                            <div className="col-xs-12 col-md-6 visible-xs visible-sm" style={styles.imageTextDiv}>
                                <h3 style={[styles.textHeaderStyle, styles.alignRight, styles.positionHeader]}>{text.executiveHeading}</h3>
                                <p style={[styles.alignRight, styles.positionText, styles.justify]}>
                                    {text.executiveDescription}
                                    <Link to="/services" style={styles.explainerLink}>
                                        Learn more
                                        <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>

                    <h2 className="text-center col-xs-12 col-md-10" style={styles.servicesHeader}>Our Products</h2>
                    <div className="row">
                        <div className="col-xs-12" style={[styles.sectionBottom]}>
                            <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <div className="col-xs-12 col-md-4">
                                    <div style={styles.imageDiv}>
                                        <img alt="Optimus Spark" style={styles.optimusLogo} className="img img-responsive" src={optimusLogo} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-6" style={styles.imageTextDiv}>
                                    <h3 style={[styles.textHeaderStyle, styles.alignLeft, styles.positionHeader]}>{text.optimusHeading}</h3>
                                    <p style={[styles.alignLeft, styles.positionText, styles.justify]}>
                                        {text.optimusDescription}
                                        <Link to="/products" style={styles.explainerLink}>
                                            Learn more
                                        <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Radium(Explainer2);


// WEBPACK FOOTER //
// ./src/components/Explainer/2/Explainer2.js